import React from 'react'

import styles from './ConfirmationWindow.module.css'; 
import { Box, Typography, Button } from '@mui/material';

const ConfirmationWindow =({cancelFunction, confirmFunction, title, name, colors}) => {
  return (
    <Box className={styles.fixedMid}>
        <Box className={styles.windowBox} sx={{backgroundColor: 'rgba(0, 0, 0, 0.95)'}}>
            <Typography
                variant="h4"
                color={colors.gray[100]}
                fontWeight="bold"
                >
                {title}
            </Typography>
            <Typography
                variant="h5"
                color={colors.gray[100]}
                fontWeight="regular"
                >
                {name}
            </Typography>
            <Box className={styles.buttonBox}>
                <Button variant="outlined" color="error" onClick={() => {confirmFunction()}}>
                    Delete user
                </Button>
                <Button variant="outlined" color={colors.gray[200]} onClick={() => {cancelFunction()}}>
                    Cancel
                </Button>
            </Box>
        </Box>
    </Box>
  )
}

export default ConfirmationWindow;